import {
    Avatar,
    Box,
    Button,
    Chip,
    Grid,
    Stack,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import Close from '../../../assets/closed.png';
import LoadingContent from '../../../components/LoadingContent';
import { useNavigate } from 'react-router-dom';
import { AccountCircle } from '@mui/icons-material';
import { useEffect } from 'react';

const truncateText = (text, maxLength) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export default ({ data, isLoading, mutate }) => {
    const theme = useTheme();
    const navigation = useNavigate();
    const matchSm = useMediaQuery(theme.breakpoints.up('sm'));

    if (isLoading) return <LoadingContent label="Buscando resultados..." />;

    console.log(data);

    return (
        <>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <Stack
                        direction="row"
                        my={2}
                        columnGap={!matchSm ? 1 : 3}
                        sx={{ overflowX: 'scroll', pb: 2, maxWidth: '100%' }}
                    >
                        {data?.profiles?.map(profile => (
                            <Box
                                key={profile.id || profile.User.username}
                                onClick={e => navigation(`/anfitriao/@${profile.User.username}`)}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Avatar
                                    sx={{ width: 95, height: 95 }}
                                    src={profile.User.profileImage}
                                />
                                <Tooltip title={`@${profile.User.username}`} arrow>
                                    <Typography
                                        textAlign="center"
                                        sx={{
                                            maxWidth: '120px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                transform: 'scale(1.05)',
                                            },
                                        }}
                                    >
                                        {truncateText(`@${profile.User.username}`, 20)}
                                    </Typography>
                                </Tooltip>
                            </Box>
                        ))}
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <Stack
                        display="grid"
                        gridTemplateColumns={`repeat(${matchSm ? '2' : '1'}, 1fr)`}
                        gridAutoRows="1fr"
                        gap={2}
                    >
                        {data?.meetings?.map(meeting => (
                            <Box
                                key={meeting.id}
                                sx={{
                                    border: `1px solid ${theme.palette.grey[400]}`,
                                    borderRadius: 2,
                                    p: 2,
                                    backgroundColor: theme.palette.grey[50],
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Avatar
                                        src={meeting?.Profile?.User?.profileImage}
                                        sx={{ width: 80, height: 80 }}
                                    />
                                    <div>
                                        <Typography variant="h5">{meeting.title}</Typography>
                                        <Typography variant="subtitle2">
                                            <Tooltip title={`@${meeting?.Profile.User?.username}`} arrow>
                                                <Chip
                                                    size="small"
                                                    label={truncateText(`@${meeting?.Profile.User?.username}`, 20)}
                                                    icon={<AccountCircle />}
                                                    onClick={e =>
                                                        navigation(
                                                            `/anfitriao/@${meeting?.Profile.User?.username}`,
                                                        )
                                                    }
                                                    sx={{
                                                        transition: 'transform 0.3s ease',
                                                        '&:hover': {
                                                            transform: 'scale(1.05)',
                                                        },
                                                    }}
                                                />
                                            </Tooltip>
                                        </Typography>
                                        <Typography variant="subtitle1" mt={1} color="text.secondary">
                                            {meeting.pricing ? `Preço: R$ ${meeting.pricing.toFixed(2)}` : 'Gratuito'}
                                        </Typography>
                                    </div>
                                </Stack>
                                <Stack
                                    direction="row"
                                    alignItems="flex-end"
                                    justifyContent="space-between"
                                    mt={2}
                                >
                                    <Stack direction="row" columnGap={1}>
                                        {meeting.raffle ? (
                                            <Chip size="small" label="Seleção" />
                                        ) : (
                                            <Chip size="small" label="Agendamento" />
                                        )}
                                        {meeting.visible_public ? (
                                            <Chip size="small" label="Público" />
                                        ) : (
                                            <Chip size="small" label="Privado" />
                                        )}
                                    </Stack>

                                    <Button
                                        onClick={e =>
                                            navigation(`/encontrar/${meeting.id}/detalhes`)
                                        }
                                        variant="contained"
                                        size="small"
                                    >
                                        Ver detalhes
                                    </Button>
                                </Stack>
                            </Box>
                        ))}
                    </Stack>
                </Grid>
                {Boolean(data?.meetings) && !Boolean(data?.meetings.length) && (
                    <Grid item xs={12} textAlign="center">
                        <Box component="img" src={Close} sx={{ width: 120 }} />
                        <Typography>Nenhum encontro listado</Typography>
                    </Grid>
                )}
            </Grid>
        </>
    );
};
